//Pages
export const IMAGE_PAGE = "/images";
export const MAP_PAGE = "/map";
export const JOKE_PAGE = "/joke";

//Colors
export const BROWN = "#63474D";
export const BROWN_LIGHT ="345555"
export const BLACK_LIGHT = "#2c2c34";
export const GRAY_LIGHT = "#545463";
export const ORANGE_YELLOW = "#d6a184";
export const DEEP_BLUE = "#000000";

//Breakpoints
export const PHONE_BREAK = "889px";
export const LAPTOP_BREAK = "1375px";
